<template>
  <div style="display: inline-block">
    <span :class="starCssClass()"></span>
  </div>
</template>
<script>
export default {
  props: ['rating'],

  methods: {
    starCssClass () {
      const roundedRating = (Math.round(this.rating * 2) / 2).toString().replace('.', '_')
      return ['dbs_pr-common-rating__star dbs_pr-common-rating__star--star-', roundedRating].join('')
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Rating.vue